import "core-js/modules/es.array.push.js";
import "core-js/modules/es.number.constructor.js";
import addactivityinfo from './addactivityinfo';
import activityproduct from './activityproduct';
import integraldoubling from './integraldoubling';
import addspecialoffer from './addspecialoffer';
import AddActivitySuccess from './AddActivitySuccess';
import activityDyx from './activityDyx.vue';
export default {
  name: 'addActivity',
  i18n: require('../i18n-activity'),
  components: {
    addactivityinfo: addactivityinfo,
    activityproduct: activityproduct,
    addspecialoffer: addspecialoffer,
    integraldoubling: integraldoubling,
    AddActivitySuccess: AddActivitySuccess,
    activityDyx: activityDyx
  },
  data: function data() {
    return {
      basicInformation: {},
      basicProductContent: {},
      currentTab: 0,
      form: null,
      activityType: 0
    };
  },
  activated: function activated() {
    this.activityType = Number(this.$route.query.activityType);
  },
  created: function created() {
    this.activityType = Number(this.$route.query.activityType);
  },
  methods: {
    nextStep: function nextStep(obj) {
      console.log(obj, 12344656);
      this.basicInformation = obj;
      if (this.currentTab < 4) {
        this.currentTab += 1;
      }
    },
    nextStep2: function nextStep2(obj) {
      console.log(obj, 12344656);
      this.basicProductContent = obj;
      if (this.currentTab < 4) {
        this.currentTab += 1;
      }
    },
    prevStep: function prevStep() {
      if (this.currentTab > 0) {
        this.currentTab -= 1;
      }
    },
    release: function release() {
      this.$router.push({
        path: "/marketing/activity/activityList"
      });
    },
    finish: function finish(type) {
      this.$router.push({
        // path: "/marketing/activity/activityList",
        path: '/marketing/activity/addActivity',
        query: {
          activityType: type
        }
      });
      // this.currentTab = 0
      window.location.reload();
    }
  }
};